import React from 'react';
import PropTypes from 'prop-types';
import MobileCinema from 'components/MobileFilters/MobileCinema';
import Close from '../../assets/Close.svg';
import './mobile-cinema-filter-modal.scss';


const MobileCinemaFilterModal = ({ modalOpen, onClose, cinemas, selectCinema, selectedCinema }) => (
  <div className={`react-cinema-filter-mobile-modal${modalOpen ? '' : ' none'}`}>
    <div className="react-cinema-filter-mobile-modal-header">
      <div className="react-cinema-filter-mobile-modal-header-title">Válassz mozit!</div>
      <Close onClick={() => { onClose(); }} />
    </div>
    <div className="react-cinema-filter-mobile-boxes-container">
      {cinemas && cinemas.map(cinema => (
        <MobileCinema
          key={cinema.id.toString()}
          id={cinema.id}
          title={cinema.name.includes('Mozi') ? cinema.name.replace('Mozi', '') : cinema.name.replace('artmozi', '')}
          onClick={() => { selectCinema(cinema.id); onClose(); }}
          selectedCinema={selectedCinema}
          logo={cinema.logo}
        />
      ))}
      <div className="react-cinema-filter-mobile-box-placeholder" />
      <div className="react-cinema-filter-mobile-box-placeholder" />
      <div className="react-cinema-filter-mobile-box-placeholder" />
      <div className="react-cinema-filter-mobile-box-placeholder" />
      <div className="react-cinema-filter-mobile-box-placeholder" />
    </div>
  </div>
);

MobileCinemaFilterModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectCinema: PropTypes.func.isRequired,
  selectedCinema: PropTypes.number.isRequired,
  cinemas: PropTypes.arrayOf(PropTypes.shape({})),
};

MobileCinemaFilterModal.defaultProps = {
  cinemas: null,
};

export default MobileCinemaFilterModal;
